import { Controller } from '@hotwired/stimulus';
import { toHalfWidthDigits } from '../lib/half_width';

export default class extends Controller {
  static values = { kind: String };

  normalize() {
    const value = toHalfWidthDigits(this.element.value).trim();
    if (this.kindValue === 'number') {
      this.element.value = this.formatNumber(value);
    } else if (this.kindValue === 'date') {
      this.element.value = value.replace(/[／．－ー.-]/g, '/');
    } else {
      this.element.value = value;
    }
  }

  formatNumber(value) {
    const digits = value.replace(/[，,、\s円]/g, '').replace(/^[－ー−]/, '-');
    if (!/^-?\d+$/.test(digits)) return value;
    return Number(digits).toLocaleString('ja-JP');
  }
}
